import './scss/main.scss';
import 'bootstrap/js/index.esm';
import WOW from 'wow.js'

// Supports weights 100-900
import '@fontsource-variable/roboto';
import '@fontsource/source-sans-pro';
import '@fontsource/source-serif-pro';

import '~icons/carbon/arrow-left'
import '~icons/carbon/arrow-right'
import '~icons/mdi/leaf'
import '~icons/mdi/tree'
import '~icons/mdi/terrain'
import '~icons/mdi/fence'
import '~icons/mdi/watering-can'
import '~icons/mdi/snowflake'
import '~icons/mdi/flower'
import '~icons/mdi/shovel'
import '~icons/mdi/account-heart'
import '~icons/mdi/clock-check'
import '~icons/mdi/image'
import '~icons/mdi/image-outline'
import '~icons/mdi/message'
import '~icons/mdi/pencil'
import '~icons/mdi/shovel'

new WOW().init();